"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBearer = void 0;
var axios_1 = __importDefault(require("axios"));
var auth = __importStar(require("../helpers/auth"));
function authHeader() {
    axios_1.default.interceptors.request.use(function (config) {
        var bearer = getBearer();
        if (bearer) {
            config.headers.Authorization = bearer;
        }
        return config;
    });
}
function getBearer() {
    var token = auth.getToken();
    if (!token) {
        return;
    }
    return "Bearer " + token;
}
exports.getBearer = getBearer;
exports.default = authHeader;
